import {
  ApiResListsType,
  OhsApiRequestName,
  OhsApiRequestOptions,
  RequestType,
} from 'global-services/api/OhsApiModels';
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';

import { OhsWmmSysFieldListsFilterPayload } from './models/OhsWmmSysFieldModels';
import OhsWmmSysFieldRecord from './models/OhsWmmSysFieldRecord';

export const fetchWmmSysField = (_id: string): Promise<any> => {
  return OhsApiRequest(RequestType.Module, ModuleType.Wmm, OhsApiRequestName.Fetch, {
    _id,
  });
};

export const addWmmSysField = (payload: any, options?: OhsApiRequestOptions) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.Wmm,
    OhsApiRequestName.Create,
    payload,
    options
  );
};

export const editWmmSysField = (payload: any, options?: OhsApiRequestOptions) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.Wmm,
    OhsApiRequestName.Edit,
    payload,
    options
  );
};

export const getWmmSysFieldLists = (
  filterInfo: OhsWmmSysFieldListsFilterPayload
): Promise<ApiResListsType<OhsWmmSysFieldRecord[]> | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.Wmm, OhsApiRequestName.List, {
    filter: filterInfo,
    forType: ModuleType.Injury,
  });
};

export const archiveUnarchiveWmmSysField = (id: string, archived: boolean) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.Wmm,
    archived ? OhsApiRequestName.Archive : OhsApiRequestName.UnArchive,
    {
      _id: id,
    }
  );
};

export const deleteWmmSysField = (id: string) => {
  return OhsApiRequest(RequestType.Module, ModuleType.Wmm, OhsApiRequestName.Delete, {
    _id: id,
  });
};
